import { DocumentMetadata } from "@/model/Procedure/DocumentMetadata";

export class DocumentImportPlan {
  public ProcedureId: number;
  public NodeSchemeId: number;
  public NodeId: number;
  public ParrentId: number;
  public OrganisationId: number;
  public SchemeId: number;
  public DocumentId: number;
  public SchemeName: string;
  public NodeName: string;
  public ProcedureName: string;
  public UserId: number;
  public Revision: number;
  public NewRevision: number;
  public FileName: string;
  public GroupId: number;
  public Action: ImportAction;
  public StatusCode: DocumentImportErrorCodes;
  public Chapters: Array<DocumentMetadata>;
  public SortNumber: number;
}

export enum ImportAction {
  Ok = 0,
  Procedure = -1,
  Document = -2,
  NoneFound = -3,
}

export enum DocumentImportErrorCodes {
  NewPage,
  EditPage,
  UpdatedDocument,
}
